
import { Action } from 'redux';

import { TaxRateActionTypes, TaxRateState } from './types';
import { TaxRateActions } from './actions'
import { createReducer } from '../../reducer';


const unloadedState: TaxRateState = { isLoading: false, taxRates: [], loadError: null, isSaving: false, saveComplete: false, saveError: null, validationErrors: [] };

export const reducer = (state: TaxRateState, incomingAction: Action) => createReducer(state, incomingAction, unloadedState, reducerHandler);

export const reducerHandler = (state: TaxRateState, incomingAction: Action): TaxRateState => {

    const action = incomingAction as TaxRateActions;
    switch (action.type) {
        case TaxRateActionTypes.RequestTaxRates:
            return {
                ...state,
                isLoading: true,
                taxRates: state.taxRates,
                loadError: null
            };
        case TaxRateActionTypes.ReceivedTaxRates:
            const ordered = action.taxRates ? action.taxRates : [];
            ordered.sort((a, b) => a.name.localeCompare(b.name));

            return {
                ...state,
                isLoading: false,
                taxRates: ordered,
                loadError: action.error
            };
        case TaxRateActionTypes.EditTaxRate:
            return {
                ...state,
                isSaving: false,
                saveError: null,
                saveComplete: false,
                validationErrors: []
            };
        case TaxRateActionTypes.SaveTaxRate:
            return {
                ...state,
                isSaving: true,
                saveError: null,
                saveComplete: false,
                validationErrors: []
            };
        case TaxRateActionTypes.TaxRateSaved:
            return {
                ...state,
                isSaving: false,
                saveComplete: true,
                saveError: null,
                validationErrors: []
            };
        case TaxRateActionTypes.TaxRateSaveFailed:
            return {
                ...state,
                isSaving: false,
                saveError: action.error,
                saveComplete: false,
                validationErrors: action.error && action.error.validationErrors ? action.error.validationErrors : []
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // eslint-disable-next-line
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};

